import { type ReactElement } from 'react'
import { isDefined, isNotDefined, isNotEmpty, type TeamId } from '@terros/common'
import { useTeamHierarchyContext } from '../TeamHierarchyContext'
import { type Edge, ConnectionLayer } from '../../../connectionLayer'

const HIDDEN_EDGE_OPACITY = 0.45

export const TeamConnectionsLayer = (): ReactElement => {
  const { connectionSettings, layout, visibleTeamIds } = useTeamHierarchyContext()
  const { drawnTeamIds, rows } = layout

  const isHidden = (teamId: TeamId): boolean => isDefined(visibleTeamIds) && !visibleTeamIds.has(teamId)

  const drawn = rows
    .flatMap((row) => row.teams)
    .flatMap((team) => {
      const parentId = team.parentId
      if (isNotDefined(parentId) || !drawnTeamIds.has(parentId)) return []
      const edge: Edge = { start: parentId, end: team.teamId }
      return [{ edge, faded: isHidden(parentId) || isHidden(team.teamId) }]
    })

  const solidEdges = drawn.filter((item) => !item.faded).map((item) => item.edge)
  const fadedEdges = drawn.filter((item) => item.faded).map((item) => item.edge)

  return (
    <>
      <ConnectionLayer edges={solidEdges} options={connectionSettings} />
      {isNotEmpty(fadedEdges) && (
        <ConnectionLayer edges={fadedEdges} options={{ ...connectionSettings, opacity: HIDDEN_EDGE_OPACITY }} />
      )}
    </>
  )
}
